














import { Component, Vue, Prop } from 'vue-property-decorator'
import { Address } from '@/models/Address'

@Component({
  components: {
  }
})
export default class Coverage extends Vue {

  @Prop({ default: new Address() }) public address!: Address

}
